import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6a546de4&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=6a546de4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a546de4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a546de4')) {
      api.createRecord('6a546de4', component.options)
    } else {
      api.reload('6a546de4', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6a546de4&scoped=true&", function () {
      api.rerender('6a546de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hyperlinkSelect/detail.vue"
export default component.exports